import {newAxios} from './index'

export const Req_GetAllPermissionConfig = function (data) {
  return newAxios({
    url: `/i/tenant/user/group/post/get/all/data/permission/config`,
    data
  })()
}


// WEBPACK FOOTER //
// ./src/request/settingInterface.js